import {useState} from 'react';
import ArrCheckbox from '../../../components/common/arr-checkbox/ArrCheckbox';

const RadioDemo = () => {
  const [checked, setChecked] = useState(false);
  return (
    <>
      <ArrCheckbox
        label="Test"
        checked={checked}
        onChange={(value) => setChecked(value)}
      />
      <ArrCheckbox
        label="Test"
        checked={checked}
        size="medium"
        onChange={(value) => setChecked(value)}
      />
      <ArrCheckbox
        label="Test"
        checked={checked}
        size="small"
        isAllSelected={true}
        onChange={(value) => setChecked(value)}
      />
      <ArrCheckbox
        label="Test"
        checked={checked}
        isIndeterminate={true}
        size="xs"
        onChange={(value) => setChecked(value)}
      />
      <ArrCheckbox
        label="Test"
        checked={checked}
        disabled={true}
        size="large"
        onChange={(value) => setChecked(value)}
      />
      <ArrCheckbox
        label="Test"
        checked={checked}
        disabled={true}
        isIndeterminate={true}
        size="medium"
        onChange={(value) => setChecked(value)}
      />
      <ArrCheckbox
        label="Test"
        checked={checked}
        disabled={true}
        isAllSelected={true}
        size="small"
        onChange={(value) => setChecked(value)}
      />
      <ArrCheckbox
        label="Test"
        checked={checked}
        disabled={true}
        isAllSelected={true}
        size="xs"
        onChange={(value) => setChecked(value)}
      />
    </>
  );
};

export default RadioDemo;
